// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"332":"component---src-templates-index-js","532":"styles"}[chunkId] + "-" + {"332":"405d2ea47882b628cf5e","532":"df22dfcd23d3003cf694"}[chunkId] + ".js";
};